// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2PutJ","footer":"ModalError_footer__3q9W2"};